import Container from '@mui/material/Container'

import Heading from '~/client/components/Heading'

export default function ContactPage() {
  return <Container>
    <Heading my={4} variant="major">Contact</Heading>
    <p>DataPal is in early Alpha.</p>
    <p>
      {`Contact us at `}
      <a href="mailto:developers@datapal.me">contact@datapal.me</a>
    </p>
  </Container>
}
